import { render, staticRenderFns } from "./BaseModalPreview.vue?vue&type=template&id=573f00f0&"
import script from "./BaseModalPreview.vue?vue&type=script&lang=js&"
export * from "./BaseModalPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports